import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Button, Container, Row, Col } from 'reactstrap';

/**
 * K12NET (ve benzer redirect tabanlı SSO'lar) başarısız olduğunda backend'in
 * K12NET_FAILURE_REDIRECT_URI'si üzerinden `?error=<mesaj>` ile yönlendirdiği sayfa.
 */
const SsoFailure = () => {
  const { search } = useLocation();
  const history = useHistory();
  const errorMessage =
    new URLSearchParams(search).get('error') ||
    'Giriş sırasında bir hata oluştu. Lütfen tekrar deneyin.';

  return (
    <Container className="text-center" style={{ marginTop: '80px' }}>
      <Row>
        <Col className="ml-auto mr-auto" md="6">
          <h3>Giriş yapılamadı</h3>
          <p>{errorMessage}</p>
          <Button
            className="btn-round"
            color="info"
            onClick={() => history.replace('/signin')}
          >
            Giriş sayfasına dön
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default SsoFailure;
